export default __webpack_public_path__ + "static/media/sns_logo-horizontal.368ae29c.svg";